export default __webpack_public_path__ + "static/media/jsicon.3e818d77.webp";